import { styled } from '@mui/material/styles'

export const WizardHeader = styled('div', {
  name: 'WizardHeader',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
})(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1),
  backgroundColor: '#393939',
  color: 'rgba(255, 255, 255, 0.87)',
}))
